if (document.querySelector('trade-in-drawer')) {
  class TradeInDrawer extends HTMLElement {
    constructor() {
      super();
      this.item = document.querySelector('.cart-item')
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    }


    /**
     * Open the trade-in cart drawer, and render the contents.
     *
     * @param {*} tradein - (Optional) Pass in a trade-in to avoid an extra fetch
     * @param {*} triggeredBy - (Optional)
     */
    async open(tradein, triggeredBy) {
      if (tradein) {
        this.renderContents(tradein);
      } else {
        const tradeinUuid = localStorage.getItem('tradeinUuid');
        if (tradeinUuid) {
          const fetchedTradein = await getTradein(tradeinUuid);
          this.renderContents(fetchedTradein);
        }
      }

      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => { this.classList.add('animate', 'active') });

      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    renderContents(tradein) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      const { tradeinItems } = tradein;

      //render items
      const itemList = this.querySelector('trade-in-item-list');
      itemList?.renderTradeInItems(tradeinItems);

      //renders footer
      const cartFooter = this.querySelector('trade-in-cart-footer');
      cartFooter?.renderFooter(tradeinItems);

      // renders number of items in header
      const numberOfItemsHeader = document.querySelector('trade-in-cart-item-count');
      numberOfItemsHeader?.renderNumberCartItems(tradeinItems.length);

      // closes the cart if the cart is empty
      this.closeEmptyCart(tradeinItems.length);
    }

    closeEmptyCart(totalItems) {
      if (totalItems === 0) {
        setTimeout(() => {
          this.close()
        }, 100);
      }
      return;
    }

    renderFooter(parsedState) {
      const totalsCreditValue = this.querySelector('.totals__credit-value');

      const { tradeinValueLow, tradeinValueHigh } = parsedState;

      totalsCreditValue.textContent = `${formatMoneyForTradein(tradeinValueLow)} - ${formatMoneyForTradein(tradeinValueHigh)}`;
    }
  }
  customElements.define('trade-in-drawer', TradeInDrawer);
}
